const TRAFFIC_SOURCE_LIST = [
  "google",
  "facebook",
  "twitter",
  "linkedin",
  "instagram",
] as const;

/**
 * Detect traffic source from referrer and common UTM parameters.
 * Returns a capitalized label, e.g. "Google", or "Direct" if unknown.
 */
export const detectTrafficSource = (): {trafficSource: string, sourceLink: string} => {
  if (typeof window === "undefined") {
    return {trafficSource: "Direct", sourceLink: ''};
  }

  const referrer = document.referrer || "";

  const urlParams = new URLSearchParams(window.location.search);
  const utmSource = urlParams.get("utm_source") || "";
  const utmMedium = urlParams.get("utm_medium") || "";
  const utmCampaign = urlParams.get("utm_campaign") || "";

  const clueList = [utmSource, utmMedium, utmCampaign, referrer];

  for (const clue of clueList) {
    if (!clue) continue;

    const lowerClue = clue.toLowerCase();
    for (const source of TRAFFIC_SOURCE_LIST) {
      if (lowerClue.includes(source)) {
        const trafficSource =  source
          .split(" ")
          .map(
            (word) =>
              word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");
        return {trafficSource, sourceLink: window.location.href}
      }
    }
  }

  return {trafficSource: "Direct", sourceLink: ''};
};


